// extracted by css-extract-rspack-plugin
export default {"root":"vXegc","radio":"XTmFw","label":"fnJ5q","description":"Ysrub","icon":"KRNGg","labelWrapper":"Hqlzv"};